/** @jsx jsx */

import { Fragment, useState } from 'react';

import { css, jsx } from '@emotion/core';

import { Icon, Surface, Text } from '@zapier/design-system';

const Styles = {
  button: css`
    background: transparent;
    border: none;
    padding: 0px;
    position: absolute;
    right: 17px;
    top: 17px;

    &:hover {
      cursor: pointer;
    }
  `,
  list: css`
    list-style: disc;
    margin-bottom: 1em;
    margin-left: 1em;
  `,
  readMore: css`
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 0px;
    text-decoration: underline;
  `,
  root: css`
    padding: 30px 70px 30px 40px;
    position: relative;
  `,
};

type Props = {
  onDismiss: () => void;
};

function PrivateIntegrationMsg({ onDismiss }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Surface backgroundColor="GrayWarm2">
      <div css={Styles.root}>
        <Text margin="0 0 1em" tag="p" type="Body3">
          You’re building a Private Integration
        </Text>
        <Text margin="0 0 1em" tag="p">
          Private integrations allow you to extend what’s possible on Zapier
          today using any API. You can start using it in Zaps as soon as you’re
          ready. Only users you share your integration with will be able to use
          it in their Zaps.
        </Text>
        {isOpen && (
          <Fragment>
            <Text margin="0 0 1em" tag="p">
              Private integrations are great for:
            </Text>
            <Text>
              <ul css={Styles.list}>
                <li>
                  Creating your own integrations that don’t yet exist on Zapier
                </li>
                <li>Iterating and experimenting with your own product</li>
                <li>Extending existing public Zapier integrations</li>
                <li>Inviting teammates to collaborate and build with</li>
              </ul>
            </Text>
          </Fragment>
        )}
        <button
          css={Styles.readMore}
          onClick={event => {
            event.preventDefault();
            setIsOpen(!isOpen);
          }}
        >
          <Text color="UiPrimaryStrongest">
            Read {isOpen ? 'less' : 'more'}
          </Text>
        </button>
        <button aria-label="Dismiss" css={Styles.button} onClick={onDismiss}>
          <Icon name="formX" size={30} />
        </button>
      </div>
    </Surface>
  );
}

export default PrivateIntegrationMsg;
